import React, { Component } from 'react'
import { Disclosure } from '@cred/react-disclosures-sdk'
import Link from 'components/link'
import Font from '@cred/react-font'
import Tooltip from 'components/tooltip'
import PropTypes from 'prop-types'
import { tooltipContent } from './tooltip-content'
import styles from './styles.scss'

const getContentSubject = theme => {
  const contentSubject = {
    fox: 'Fox Advertising Disclosure',
    thebalance1: 'The Balance Advertising Disclosure',
    investopedia1: 'Investopedia Advertising Disclosure',
  }

  return contentSubject[theme]
}

class AdvertiserDisclosure extends Component {
  static propTypes = {
    theme: PropTypes.string,
  }

  static defaultProps = {
    theme: 'fox',
  }

  render() {
    const { theme } = this.props,
      content = tooltipContent[theme] || ''

    return (
      <div className={styles.container}>
        <Link
          className={`${styles.disclosureLink} ${styles[theme]}`}
        >
          <Tooltip
            triggerContent="Advertising Disclosure"
            triggerProps={{ type: 'disclaimer', color: 'lighter' }}
            className={styles.advertiserTooltip}
            analyticsOptions={{ contentSubject: getContentSubject(theme) }}
          >
            {this.renderTooltipContent(content)}
          </Tooltip>
        </Link>
      </div>
    )
  }

  renderTooltipContent = (content) => (
    <Font type="disclaimer" className={styles.copy}>
      <Disclosure required={false} slug={content} />
    </Font>
  )
}

export { AdvertiserDisclosure }
